import ProductListView from './List';
export default ProductListView;
